module.exports = __webpack_public_path__ + "media/images/Icon_Twitter-51daf75ab3d341cbb43d31a10ec24e35.svg";